import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { getRecorderColor, toTrim } from "utils/functions";

const Container = styled.div<{ type: RecorderType }>`
  border-radius: 2px;
  font-size: ${calcRem(14)};
  color: ${COLORS.WHITE};
  ${FLEX.FlexCenterCenter};
  min-width: 90px;
  position: relative;

  background-color: ${({ theme, type }) => getRecorderColor({ theme, type })};

  ${mediaQuery.isDefault} {
    height: 28px;
  }
  ${mediaQuery.isMobile} {
    padding: 6px 8px;
    min-width: 80px;
  }
  .license-type {
    font-size: ${calcRem(10)};
    position: absolute;
    right: -1px;
    top: -3px;
    background-color: ${COLORS.WHITE};
    border-radius: 2px;
    padding: 0 2px;
    min-height: ${calcRem(12)};
    border: 1px solid ${({ theme, type }) => getRecorderColor({ theme, type })};
    line-height: 1;
    ${FLEX.FlexCenterCenter};
    font-weight: 600;
    color: ${({ theme, type }) => getRecorderColor({ theme, type })};
  }
`;

interface TypeProps {
  type: RecorderType;
  licenseType?: string | null;
  displayType?: string;
  isCloudCam?: boolean;
}

export type RecorderType =
  | "COVA"
  | "VMAX-IP"
  | "VMAX-A1"
  | "NVR"
  | "SPECTRUM"
  | "UNKNOWN";

function Type({
  type,
  licenseType,
  displayType,
  isCloudCam,
}: TypeProps): JSX.Element {
  const recorderType = toTrim(displayType ?? type);
  return (
    <Container type={type} className="recorder-type" data-tag="allowRowEvents">
      {displayType ?? type}
      {recorderType.toUpperCase() === "SPECTRUM" &&
        (isCloudCam ? (
          <span className="license-type">CloudCam</span>
        ) : (
          licenseType === "enterprise" && (
            <span className="license-type">ENT</span>
          )
        ))}
    </Container>
  );
}

export default Type;
